"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hubspotDataSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const fieldSchema = zod_1.default.object({
    name: zod_1.default.string(),
    value: zod_1.default.union([zod_1.default.string(), zod_1.default.boolean(), zod_1.default.number()]).optional(),
});
exports.hubspotDataSchema = zod_1.default.object({
    submittedAt: zod_1.default.number(),
    fields: zod_1.default.array(fieldSchema),
});
//# sourceMappingURL=hubspot.js.map